<template>
  <c-search-form :input-search-items="searchItems" :rows-per-page-items="[10,20,50]" :input-create-items="createItems"
                 :form-name="formName"
                 :fields="fields" accept-copy
                 form-type="intable"
                 key-property="workflowId"
                 search-url="/workflow/search"
                 create-url="/workflow/save"
                 delete-url="/workflow/delete"
                 delete-multi-url="/workflow/deleteList"
  >
    <workflow-create id="createDiv" :default-data="this.$parent.selectedItem" slot="createForm"
                     :input-items="createItems" style="display: none" create-url="/workflow/save"
                     form-name="lang.workflow.add_edit" ref="createForm"></workflow-create>
  </c-search-form>
</template>

<script>
  import CSearchForm from "../../../components/form/ManageForm";
  import WorkflowCreate from "./WorkflowCreate";

  export default {
    name: 'workflow-management',
    components: {WorkflowCreate, CSearchForm},
    data: () => {
      return {
        formName: "lang.workflow.title",
        searchItems: [
          {
            type: "text",
            name: "flowCode",
            label: "lang.workflow.code",
            placeHolder: "",
            focus: true
          },
          {
            type: "text",
            name: "flowName",
            label: "lang.workflow.name",
            placeHolder: ""
          }
        ],
        createItems: [
          {
            type: "text",
            name: "flowCode",
            label: "lang.workflow.code",
            validate: "required",
            maxlength: '50',
            placeHolder: "",
            focus: true
          },
          {
            type: "text",
            name: "flowName",
            label: "lang.workflow.name",
            validate: "required",
            maxlength: '250',
            placeHolder: "",
          }
        ],
        fields: [
          {value: "checkbox", sortable: false, headerStyle: "text-align:center",width:"5%"},
          {value: "index", text: "lang.common.index", sortable: false, headerStyle: "text-align:center",width:"5%"},
          {value: 'flowCode', text: 'lang.workflow.code',search:true, sortable: true, headerStyle: "text-align:left",width:"15%"},
          {value: 'flowName', text: 'lang.workflow.name',search:true, sortable: true, headerStyle: "text-align:left",width:"30%"},
          {
            value: 'createdAt',
            text: 'lang.common.create_update_at',
            sortable: true,
            dateFormat: 'dd/MM/yyyy hh:mm',
            headerStyle: "text-align:left",
            width:"10%"
          },
          {value: 'creatorName', text: 'lang.common.create_by', sortable: true, headerStyle: "text-align:left",width:"10%"},
          {
            value: 'action',
            text: "lang.common.actions",
            sortable: false,
            compound: true,
            headerStyle: "text-align:center",
            width:"25%"
          }
        ]
      }
    },
    destroyed() {
      //console.log("---havm destroyed---");
    }
  }
</script>
